export function getLoggedIn() {
  return localStorage.getItem("loggedIn")
    ? localStorage.getItem("loggedIn") === "true"
    : false;
}

export function setLoggedIn(loggedIn) {
  localStorage.setItem("loggedIn", loggedIn);
}
